import React from 'react';
import './WHMCS.css';

const WHMCSLicense = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className="seo-header">
        <h1>خرید لایسنس WHMCS | لایسنس اورجینال با بهترین قیمت | افراسل</h1>
        <p>خرید لایسنس اورجینال WHMCS با بهترین قیمت و پشتیبانی رسمی. لایسنس‌های WHMCS شامل به‌روزرسانی خودکار و نصب رایگان می‌باشند.</p>
        <meta name="description" content="خرید لایسنس WHMCS اورجینال با بهترین قیمت از افراسل. لایسنس رسمی با پشتیبانی و به‌روزرسانی خودکار." />
      </div>

      <section className="whmcs-hero">
        <div className="whmcs-hero-bg"></div>
        <div className="wrap">
          <div className="whmcs-hero-content">
            <div className="whmcs-badge">
              <span className="pulse-dot"></span>
              🛒 خرید لایسنس WHMCS
            </div>
            <h1 className="whmcs-hero-title">
              خرید لایسنس <em>WHMCS</em>
            </h1>
            <p className="whmcs-hero-desc">
              WHMCS یک سیستم مدیریت کسب‌وکار آنلاین قدرتمند است که به شما امکان می‌دهد خدمات هاستینگ، دامنه و سرور را به سادگی مدیریت کنید. با خرید لایسنس اورجینال WHMCS از افراسل، از پشتیبانی رسمی، به‌روزرسانی خودکار و بهترین قیمت بهره‌مند شوید. لایسنس‌های WHMCS شامل نصب رایگان توسط تیم حرفه‌ای ما می‌باشند.
            </p>
            <div className="whmcs-hero-stats">
              <div className="stat-item">
                <span className="stat-number">اورجینال</span>
                <span className="stat-label">۱۰۰٪ تضمینی</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۱۰۰+</span>
                <span className="stat-label">پروژه موفق</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">۲۴/۷</span>
                <span className="stat-label">پشتیبانی</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="whmcs-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              لایسنس <em>WHMCS</em> را با افراسل تجربه کنید
            </h2>
            <p className="cta-desc">
              با خرید لایسنس WHMCS از افراسل، کسب‌وکار خود را به سطح بالاتری ببرید. بهترین قیمت، پشتیبانی رسمی و نصب رایگان.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>درخواست خدمات</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WHMCSLicense;
